import React from 'react';
import { siteData } from '../../data/mock';
import { TrendingUp, Lightbulb, DollarSign, MessageCircle } from 'lucide-react';

const iconMap = [
  <TrendingUp size={28} className="text-[#0E47B0]" />,
  <Lightbulb size={28} className="text-[#0E47B0]" />,
  <DollarSign size={28} className="text-[#0E47B0]" />,
  <MessageCircle size={28} className="text-[#0E47B0]" />,
];

const Principles = () => {
  const { principles } = siteData;

  return (
    <section className="py-[60px] md:py-[80px]">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6">
        {/* Header */}
        <div className="text-center max-w-[800px] mx-auto mb-10 md:mb-14">
          <h2 className="text-[28px] md:text-[34px] font-bold text-[#1a1a2e] mb-4 leading-tight">
            {principles.title}
          </h2>
          <p className="text-[15px] text-[#4a4a6a] leading-[1.8]">
            {principles.description}
          </p>
        </div>

        {/* Principles Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {principles.items.map((item, index) => (
            <div
              key={index}
              className="bg-white border border-gray-100 rounded-xl p-6 md:p-8 hover:shadow-lg transition-shadow duration-300"
            >
              <div className="w-[65px] h-[65px] bg-[#0E47B0]/10 rounded-lg flex items-center justify-center mb-5">
                {iconMap[index]}
              </div>
              <h3 className="text-[18px] md:text-[20px] font-bold text-[#1a1a2e] mb-3 leading-snug">
                {item.title}
              </h3>
              <p className="text-[14px] md:text-[15px] text-[#4a4a6a] leading-[1.8]">
                {item.text}
              </p>
            </div>
          ))}
        </div>

        <div className="text-center mt-8 md:mt-12">
          <a
            href="#form-main"
            className="inline-block px-8 py-3.5 bg-gradient-to-r from-[#0E47B0] to-[#1a5dd4] hover:from-[#0d3d96] hover:to-[#1650b8] text-white font-bold text-sm tracking-wider rounded-lg transition-all no-underline"
          >
            {principles.ctaText}
          </a>
        </div>
      </div>
    </section>
  );
};

export default Principles;
